import { render, staticRenderFns } from "./AscPowerBiDashboardNameAirlineDatasetChoice.vue?vue&type=template&id=98e87b00&"
import script from "./AscPowerBiDashboardNameAirlineDatasetChoice.vue?vue&type=script&lang=js&"
export * from "./AscPowerBiDashboardNameAirlineDatasetChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports